const FETCH_DETAIL = 'auth/ccc/fetch-detail';
const FETCH_DETAIL_SUCCESS = 'auth/ccc/fetch-detail-success';
const FETCH_DETAIL_FAILED = 'auth/ccc/fetch-detail-failed';
const PAUSE = 'auth/ccc/pause';
const PAUSE_SUCCESS = 'auth/ccc/pause-success';
const PAUSE_FAILED = 'auth/ccc/pause-failed';
const QUANTITY = 'auth/ccc/quantity';
const QUANTITY_SUCCESS = 'auth/ccc/quantity-success';
const QUANTITY_FAILED = 'auth/ccc/quantity-failed';
const FETCH_PRODUCT_DATA = 'auth/ccc/fetch-product-data';
const FETCH_PRODUCT_DATA_SUCCESS = 'auth/ccc/fetch-product-data-success';
const FETCH_PRODUCT_DATA_FAILED = 'auth/ccc/fetch-product-data-failed';
const FETCH_LIST = 'auth/ccc/fetch-list';
const FETCH_LIST_SUCCESS = 'auth/ccc/fetch-list-success';
const FETCH_LIST_FAILED = 'auth/ccc/fetch-list-failed';
const CCC_ADDRESS_UPDATE = 'auth/ccc/address/update';
const CCC_ADDRESS_RESET = 'auth/ccc/address/reset';
const CCC_ADDRESS_SAVE = 'auth/ccc/address/save';
const CCC_ADDRESS_SAVE_FAILED = 'auth/ccc/address/save-failed';
const CCC_ADDRESS_SAVE_SUCCESS = 'auth/ccc/address/save-success';
const CCC_ADDRESS_SET_IS_EDIT_MODE = 'auth/ccc/address/set-is-edit-mode';
const CCC_ADDRESS_SET_IS_MODAL_OPEN = 'auth/ccc/address/is-modal-open';
const fetchDetail = (payload)=>({
        type: FETCH_DETAIL,
        payload
    })
;
const fetchDetailSuccess = (payload)=>({
        type: FETCH_DETAIL_SUCCESS,
        payload
    })
;
const fetchDetailFailed = (error)=>({
        type: FETCH_DETAIL_FAILED,
        error
    })
;
const pause = (payload)=>({
        type: PAUSE,
        payload
    })
;
const pauseSuccess = (payload)=>({
        type: PAUSE_SUCCESS,
        payload
    })
;
const pauseFailed = (error)=>({
        type: PAUSE_FAILED,
        error
    })
;
const quantity = (payload)=>({
        type: QUANTITY,
        payload
    })
;
const quantitySuccess = (payload)=>({
        type: QUANTITY_SUCCESS,
        payload
    })
;
const quantityFailed = (payload)=>({
        type: QUANTITY_FAILED,
        payload
    })
;
const fetchProductData = (payload)=>({
        type: FETCH_PRODUCT_DATA,
        payload
    })
;
const fetchProductDataSuccess = (payload)=>({
        type: FETCH_PRODUCT_DATA_SUCCESS,
        payload
    })
;
const fetchProductDataFailed = (payload)=>({
        type: FETCH_PRODUCT_DATA_FAILED,
        payload
    })
;
const fetchList = ()=>({
        type: FETCH_LIST
    })
;
const fetchListSuccess = (payload)=>({
        type: FETCH_LIST_SUCCESS,
        payload
    })
;
const fetchListFailed = (error)=>({
        type: FETCH_LIST_FAILED,
        error
    })
;
const updateCCCAddress = (payload)=>({
        type: CCC_ADDRESS_UPDATE,
        payload
    })
;
const resetCCCAddress = ()=>({
        type: CCC_ADDRESS_RESET
    })
;
const saveCCCAddress = (payload)=>({
        type: CCC_ADDRESS_SAVE,
        payload
    })
;
const saveCCCAddressSuccess = ()=>({
        type: CCC_ADDRESS_SAVE_SUCCESS
    })
;
const saveCCCAddressFailed = (error)=>({
        type: CCC_ADDRESS_SAVE_FAILED,
        error
    })
;
const setSubscriptionFormIsModalOpen = (payload)=>({
        type: CCC_ADDRESS_SET_IS_MODAL_OPEN,
        payload
    })
;
const setSubscriptionFormIsEditMode = (payload)=>({
        type: CCC_ADDRESS_SET_IS_EDIT_MODE,
        payload
    })
;

export { CCC_ADDRESS_RESET, CCC_ADDRESS_SAVE, CCC_ADDRESS_SAVE_FAILED, CCC_ADDRESS_SAVE_SUCCESS, CCC_ADDRESS_SET_IS_EDIT_MODE, CCC_ADDRESS_SET_IS_MODAL_OPEN, CCC_ADDRESS_UPDATE, FETCH_DETAIL, FETCH_DETAIL_FAILED, FETCH_DETAIL_SUCCESS, FETCH_LIST, FETCH_LIST_FAILED, FETCH_LIST_SUCCESS, FETCH_PRODUCT_DATA, FETCH_PRODUCT_DATA_FAILED, FETCH_PRODUCT_DATA_SUCCESS, PAUSE, PAUSE_FAILED, PAUSE_SUCCESS, QUANTITY, QUANTITY_FAILED, QUANTITY_SUCCESS, fetchDetail, fetchDetailFailed, fetchDetailSuccess, fetchList, fetchListFailed, fetchListSuccess, fetchProductData, fetchProductDataFailed, fetchProductDataSuccess, pause, pauseFailed, pauseSuccess, quantity, quantityFailed, quantitySuccess, resetCCCAddress, saveCCCAddress, saveCCCAddressFailed, saveCCCAddressSuccess, setSubscriptionFormIsEditMode, setSubscriptionFormIsModalOpen, updateCCCAddress };
//# sourceMappingURL=actions.js.map
